import { render } from "./MigracionActivos.vue?vue&type=template&id=4401865c"
import script from "./MigracionActivos.vue?vue&type=script&lang=js"
export * from "./MigracionActivos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__